<template>
    <img src="/images/promo/connect-features/mag.png"
     alt="Mag" />
</template>

<script>
export default {};
</script>
